
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[...clpslug]",
      function () {
        return require("private-next-pages/shop/[...clpslug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[...clpslug]"])
      });
    }
  